import apiConfig from "src/utils/apiConfig";

export const GET_DRIVERCALL = "drivercall/getDrivercallRequest";
export const ADD_DRIVERCALL = "drivercall/addDrivercallRequest";

export const fetchCall = (
  fromdate: string,
  todate: string,

) => {
  let endpoint = `${apiConfig.GETDRIVERCALL}/?fromdate=${fromdate}&todate=${todate}`;


  const apiobject = {
    method: "GET",
    authentication: true,
    endpoint,
  };

  return {
    type: GET_DRIVERCALL,
    payload: apiobject,
  };
};

export const AddDrivercall = (payload: any) => {
  const apiObject: any = {
    method: 'POST',
    authentication: true,
    endpoint: apiConfig.ADDDRIVERCALL,
    body: payload,
  };
  return {
    type: ADD_DRIVERCALL,
    payload: apiObject,
  };
};
